<template>
  <div class="home-iaa-content">
    <!-- PC -->
    <div class="hidden-md">
      <div class="home-iaa">
        <div class="home-text">
          <div class="blue-box"></div>
          <div class="text-pos">
            <p class="wow fadeInUp bold" data-wow-delay="0.5s">
              {{ $t("home.iaa") }}
            </p>
            <p class="wow fadeInUp bold" data-wow-delay="0.5s">
              {{ $t("home.mobility") }}
            </p>
            <p class="wow fadeInUp" data-wow-delay="0.5s">2021</p>
          </div>
        </div>
        <div class="home-pic">
          <div class="green-box wow slideInRight" data-wow-delay="0.5s"></div>
          <!-- <img src="@/assets/images/iaa-1.png" alt="" /> -->
          <div class="iaa-swiper">
            <!-- <img src="@/assets/images/iaa-1.png" alt="" /> -->
            <div class="soya-control">
              <div class="swiper-button" @click="handleChange('prev')">
                <img src="@/assets/images/swiper-left.png" alt="prev" />
              </div>
              <div class="swiper-button" @click="handleChange('next')">
                <img src="@/assets/images/swiper-right.png" alt="next" />
              </div>
            </div>
            <viewer :images="P1">
              <div class="swiper-container" id="model-iaa-mobility-swiper">
                <!-- <div class="soya-control">
                <div class="swiper-button" @click="handleChange('prev')">
                  <img src="@/assets/images/swiper-left.png" alt="prev" />
                </div>
                <div class="swiper-button" @click="handleChange('next')">
                  <img src="@/assets/images/swiper-right.png" alt="next" />
                </div>
              </div> -->

                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) of P1"
                    :key="index"
                  >
                    <div class="image-box">
                      <img :src="item.imgUrl" alt="iaa" />
                    </div>
                  </div>

                  <!-- <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-1.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-2.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-3.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-4.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-5.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-6.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-7.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-8.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-9.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-10.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-11.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-12.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-13.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-14.jpg" alt="" />
                  </div>
                </div> -->
                </div>
              </div>
            </viewer>
          </div>
          <div class="pic-text">
            <p class="wow fadeInUp p1 bold" data-wow-delay="0.5s">
              {{ $t("home.messe") }}
            </p>
            <p class="wow fadeInUp p1 bold" data-wow-delay="0.5s">
              {{ $t("home.munchen") }}
            </p>
            <div class="small">
              <p class="wow fadeInUp bold" data-wow-delay="0.5s">
                {{ $t("home.hallea1") }}
              </p>
              <p class="wow fadeInUp" data-wow-delay="0.5s">
                {{ $t("home.standNrB42") }}
              </p>
            </div>
          </div>
        </div>
        <img
          src="@/assets/images/iaa-2.png"
          class="pc-iaa-two wow slideInRight"
          alt=""
        />
      </div>
    </div>

    <!-- Mobile -->
    <div class="visible-md">
      <div class="mobile-home-iaa">
        <div
          class="mobile-green-box wow slideInRight"
          data-wow-delay="0.5s"
        ></div>
        <div class="mobile-blue">
          <div class="mobile-blue-box"></div>
          <!-- <img src="@/assets/images/mobile-iaa.png" alt="" /> -->
          <div class="mobile-iaa-swiper">
            <div class="soya-control">
              <!-- <div class="swiper-button" @click="handleMobileChange('prev')">
                  <img src="@/assets/images/swiper-left.png" alt="prev" />
                </div> -->
              <div class="swiper-button" @click="handleMobileChange('next')">
                <img src="@/assets/images/swiper-right.png" alt="next" />
              </div>
            </div>
            <viewer :images="P1">
              <div
                class="swiper-container"
                id="mobile-model-iaa-mobility-swiper"
              >
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) of P1"
                    :key="index"
                  >
                    <div class="image-box">
                      <img :src="item.imgUrl" alt="iaa" />
                    </div>
                  </div>
                  <!-- <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-1.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-2.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-3.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-4.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-5.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-6.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-7.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-8.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-9.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-10.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-11.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-12.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-13.jpg" alt="" />
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="image-box">
                    <img src="@/assets/images/iaa-14.jpg" alt="" />
                  </div>
                </div> -->
                </div>
              </div>
            </viewer>
          </div>
        </div>
        <div class="mobile-text-pos">
          <p class="wow fadeInUp p1 bold" data-wow-delay="0.5s">
            {{ $t("home.iaa") }}
          </p>
          <p class="wow fadeInUp p1 bold" data-wow-delay="0.5s">
            {{ $t("home.mobility") }}
          </p>
          <p class="wow fadeInUp p1" data-wow-delay="0.5s">2021</p>
        </div>

        <img
          src="@/assets/images/iaa-2.png"
          class="iaa-two wow slideInRight"
          alt=""
        />
        <div class="mobile-pic-text">
          <p class="wow fadeInUp p1 bold" data-wow-delay="0.5s">
            {{ $t("home.messe") }}
          </p>
          <p class="wow fadeInUp p1 bold" data-wow-delay="0.5s">
            {{ $t("home.munchen") }}
          </p>
          <div class="small">
            <p class="wow fadeInUp bold" data-wow-delay="0.5s">
              {{ $t("home.hallea1") }}
            </p>
            <p class="wow fadeInUp" data-wow-delay="0.5s">
              {{ $t("home.standNrB42") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import Swiper from "swiper";
export default {
  data() {
    return {
      P1: [
        {
          imgUrl: require("../../assets/images/iaa-1.jpg"),
        },
        {
          imgUrl: require("../../assets/images/iaa-2.jpg"),
        },
        {
          imgUrl: require("../../assets/images/iaa-3.jpg"),
        },
        {
          imgUrl: require("../../assets/images/iaa-4.jpg"),
        },
        {
          imgUrl: require("../../assets/images/iaa-5.jpg"),
        },
        {
          imgUrl: require("../../assets/images/iaa-6.jpg"),
        },
        {
          imgUrl: require("../../assets/images/iaa-7.jpg"),
        },
        // {
        //   imgUrl: require("../../assets/images/iaa-8.jpg"),
        // },
        // {
        //   imgUrl: require("../../assets/images/iaa-9.jpg"),
        // },
        // {
        //   imgUrl: require("../../assets/images/iaa-10.jpg"),
        // },
        // {
        //   imgUrl: require("../../assets/images/iaa-11.jpg"),
        // },
        {
          imgUrl: require("../../assets/images/iaa-12.jpg"),
        },
        {
          imgUrl: require("../../assets/images/iaa-13.jpg"),
        },
        {
          imgUrl: require("../../assets/images/iaa-14.jpg"),
        },
      ],
    };
  },
  mounted() {
    new WOW().init();
    this.swiperInit();
  },
  methods: {
    handleChange(dir) {
      if (dir === "prev") {
        this.swiper.slidePrev();
      } else {
        this.swiper.slideNext();
      }
    },
    handleMobileChange(dir) {
      if (dir === "prev") {
        this.mobileswiper.slidePrev();
      } else {
        this.mobileswiper.slideNext();
      }
    },
    swiperInit() {
      this.swiper = new Swiper("#model-iaa-mobility-swiper", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        speed: 700,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          pauseOnMouseEnter: true,
          delay: 2000,
          disableOnInteraction: true,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      });

      this.mobileswiper = new Swiper("#mobile-model-iaa-mobility-swiper", {
        speed: 700,
        loop: true,
        allowTouchMove: true,
        autoplay: {
          pauseOnMouseEnter: true,
          delay: 2000,
          disableOnInteraction: true,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-pos {
  position: absolute;
  top: 18%;
  left: 35%;
  p {
    font-size: 60px;
    line-height: 60px;
    color: #3e3e3e;
  }
}
.blue-box {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 72%;
  background: #c6e7fb;
  border-top: 1px solid #000;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
}
.pc-iaa-two {
  position: absolute;
  width: 31%;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.home-iaa {
  position: relative;
  min-height: 900px;
  display: flex;
  overflow: hidden;
  border-bottom: 1px solid #000;
  justify-content: space-between;
  .home-text {
    width: 47%;
    text-align: left;
    position: relative;
  }
  .home-pic {
    position: relative;
    width: 50%;
    .iaa-swiper {
      width: 69%;
      float: right;
      position: relative;
      img {
        height: 100%;
      }
    }
    .green-box {
      width: 50%;
      height: 167px;
      background: #67ffb8;
      float: right;
      border-left: 1px solid #000;
      border-right: 1px solid #000;
    }
    img {
      width: 100%;
    }
    .pic-text {
      width: 54%;
      position: absolute;
      right: 0%;
      bottom: 60px;
      margin: 10% auto 0 auto;
      text-align: left;
      .p1 {
        font-size: 55px;
        color: #333;
      }
      .small {
        margin-top: 13px;
        p {
          font-size: 24px;
          line-height: 35px;
          color: #333;
        }
      }
    }
  }
}
.soya-control {
  display: flex;
  position: absolute;
  width: 100%;
  height: 50px;
  bottom: 10px;
  left: 0;
  z-index: 999;
  justify-content: space-between;
  padding: 0 15px;
  .swiper-button {
    cursor: pointer;
    img {
      width: 40px !important;
      height: auto !important;
    }
  }
}
@media (max-width: 1450px) {
  .pc-iaa-two {
    position: absolute;
    width: 37%;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}
@media (max-width: 1200px) {
}
@media (max-width: 767px) {
  .soya-control {
    display: flex;
    position: absolute;
    width: 100%;
    height: 50px;
    bottom: 10px;
    left: 0;
    z-index: 999;
    justify-content: flex-end;
    padding: 0 15px;
    .swiper-button {
      img {
        width: 35px !important;
        height: auto !important;
      }
    }
  }
  .mobile-home-iaa {
    position: relative;
    // min-height: 502px;
    overflow: hidden;
    .mobile-text-pos {
      position: absolute;
      text-align: left;
      top: 67px;
      left: 20px;
      .p1 {
        font-size: 42px;
        color: #333;
      }
    }
    .mobile-green-box {
      position: absolute;
      top: 0;
      right: 0;
      width: 30%;
      height: 240px;
      background: #67ffb8;
      border-left: 1px solid #000;
      border-bottom: 1px solid #000;
    }
    .mobile-blue {
      position: relative;
      top: 166px;
      width: 100%;
      height: 336px;
      overflow: hidden;
      .mobile-blue-box {
        position: absolute;
        top: 0px;
        left: 0;
        width: 75%;
        height: 100%;
        border: 1px solid #000;
        background: #c6e7fb;
      }
      .mobile-iaa-swiper {
        position: absolute;
        bottom: 0px;
        right: 0;
        width: 310px;
        img {
          width: 100%;
        }
      }
      // img {
      //   position: absolute;
      //   bottom: 0px;
      //   right: 0;
      //   width: 310px;
      // }
    }
  }
  .iaa-two {
    display: flex;
    justify-content: start;
    width: 75%;
    margin-top: 166px;
  }
  .mobile-pic-text {
    width: 100%;
    margin: 10% auto 0 20px;
    text-align: left;
    .p1 {
      font-size: 40px;
      color: #333;
    }
    .small {
      margin-top: 13px;
      p {
        font-size: 20px;
        color: #333;
      }
    }
  }
}
</style>
<style>
.viewer-footer {
  bottom: 30px;
}
.viewer-toolbar > ul > li {
  background: rgba(255, 255, 255, 0.4);
}
.viewer-toolbar > ul > li:focus,
.viewer-toolbar > ul > li:hover {
  background: rgba(255, 255, 255, 0.5);
}
.viewer-toolbar > ul > li:nth-child(1) {
  margin-right: 20px;
}
</style>